import React from 'react';
import PropTypes from 'prop-types';
import PermissionFlag from './PermissionFlag';
import ParamsPermissionFlags from './ParamsPermissionFlags';

const PermissionControls = ({ permission, inputNamePrefix, updateFlag, readOnly = false }) => (
  <>
    <td>
      <PermissionFlag
        inputNamePrefix={inputNamePrefix}
        flagName="write_urls"
        flagValue={permission.write_urls}
        updateFlag={updateFlag}
        readOnly={readOnly}
      />
    </td>
    <td>
      <ParamsPermissionFlags
        permission={permission}
        inputNamePrefix={inputNamePrefix}
        updateFlag={updateFlag}
        readOnly={readOnly}
      />
    </td>
    <td>
      <PermissionFlag
        inputNamePrefix={inputNamePrefix}
        flagName="write_presets"
        flagValue={permission.write_presets}
        updateFlag={updateFlag}
        readOnly={readOnly}
      />
    </td>
    <td>
      <PermissionFlag
        inputNamePrefix={inputNamePrefix}
        flagName="write_project"
        flagValue={permission.write_project}
        updateFlag={updateFlag}
        readOnly={readOnly}
      />
    </td>
  </>
);

PermissionControls.propTypes = {
  permission: PropTypes.object.isRequired,
  inputNamePrefix: PropTypes.string.isRequired,
  updateFlag: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};

export default PermissionControls;